const messages = {
    accountBox: {
        title: "Oversikt",
        description: "Følg kampanjane og poenga dine raskt.",
        button: "OPNE OVERSIKT",
    },
};

export default {
    messages,
};
